const GridContainer = (props) => {
	return (
		<div className={"grid m-auto gap-4 grid-cols-1 w-11/12 xl:w-4/5 " + props.extraClass}>{props.children}</div>
	);
}
 
export default GridContainer;